import React, { Component } from "react";

import PrayerImg from "../../assets/images/ministries/grid/Prayer.jpg";
import PastoralCareImg from "../../assets/images/ministries/grid/PastoralCare.jpg";
import MercyMinistryImg from "../../assets/images/ministries/grid/MercyMinistry.jpg";
import ConnectGroupImg from "../../assets/images/ministries/grid/ConnectGroup.jpg";
import ChildrensMinistryImg from "../../assets/images/ministries/grid/Children.jpg";
import YouthMinistryImg from "../../assets/images/ministries/grid/Youth.jpg";
import LittleSquirtsImg from "../../assets/images/ministries/grid/LittleSquirts.jpg";

class Ministries extends Component {
	constructor(props) {
		super(props);
		var bgClass = props.background === "dark" ? "special-row" : "";
		this.state = { backgroundClass: bgClass };
	}
	render() {
		return (
			<section id="ministries" className={`padding100 ${this.state.backgroundClass}`}>
				<div className="container">
					<h1 className="text-center">
						CRCK <strong>Ministries</strong>
					</h1>
					<div className="divider">
						<i className="fa fa-star"></i>
					</div>

					<div className="container-fluid">
						<div className="row">
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/YouthMinistry">
											<img className="img-responsive" src={YouthMinistryImg} width="263" height="263" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/YouthMinistry">
											<h4>Youth Ministry</h4>
										</a>
										<small className="styleColor">Morph, Cadets & GEMS</small>
									</div>
								</div>
							</div>
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/ChildrensMinistry">
											<img className="img-responsive" src={ChildrensMinistryImg} width="263" height="263" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/ChildrensMinistry">
											<h4>Children</h4>
										</a>
										<small className="styleColor">Sunday Services</small>
									</div>
								</div>
							</div>
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/LittleSquirts">
											<img className="img-responsive" src={LittleSquirtsImg} width="255" height="272" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/LittleSquirts">
											<h4>Little Squirts</h4>
										</a>
										<small className="styleColor">Playgroup for under 5s</small>
									</div>
								</div>
							</div>
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/ConnectGroups">
											<img className="img-responsive" src={ConnectGroupImg} width="263" height="263" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/ConnectGroups">
											<h4>Connect Groups</h4>
										</a>
										<small className="styleColor">Read the Bible with others</small>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/MercyMinistry">
											<img className="img-responsive" src={MercyMinistryImg} width="263" height="263" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/MercyMinistry">
											<h4>Mercy Ministry</h4>
										</a>
										<small className="styleColor">Care for those in need</small>
									</div>
								</div>
							</div>
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/PastoralCare">
											<img className="img-responsive" src={PastoralCareImg} width="263" height="263" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/PastoralCare">
											<h4>Pastoral Care</h4>
											<small className="styleColor">&nbsp;</small>
										</a>
									</div>
								</div>
							</div>
							<div className="col-md-3 box">
								<div className="item-box">
									<figure>
										<a href="/Prayer">
											<img className="img-responsive" src={PrayerImg} width="263" height="263" alt="" />
										</a>
									</figure>
									<div className="item-box-desc">
										<a href="/Prayer">
											<h4>Prayer</h4>
											<small className="styleColor">&nbsp;</small>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default Ministries;
